import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useSelector } from "react-redux";
import { AddCircle, Edit2, Eye, Trash } from "iconsax-react";
import { Link } from "react-router-dom";
import ReasonModal from "../ReasonModal";
import CustomPagination from "../../Utils/CustomPagination";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function List(props) {
  const [bomList, setBomList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [bomName, setBomName] = useState("");
  const [productName, setProductName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [plantName, setPlantName] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [plantList, setPlantList] = useState([]);
  const [startDate, endDate] = dateRange;
  const [search, setSearch] = useState("");
  const [product, setProduct] = useState([]);

  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: (
        <div>
          BOM Name <br />
        </div>
      ),
      selector: (row) => row.bom_name,
    },
    {
      name: (
        <div>
          Product Name <br />
        </div>
      ),
      selector: (row) => `${row.product_name} - (${row.product_code}) - ${row?.size}${row.unit?.toUpperCase() || ""}`.trim(),
      width:'350px'
    },
    // {
    //   name: (
    //     <div>
    //       Product Code <br />
    //     </div>
    //   ),
    //   selector: (row) => row.product_code,
    // },
    {
      name: (
        <div>
          Plant Location/Code <br />
        </div>
      ),
      selector: (row) => row.plant_name,
    },
    {
      name: (
        <div>
          Machine Type <br />
        </div>
      ),
      selector: (row) => row.machine_type,
    },
    {
      name: (
        <div>
          Date <br />
        </div>
      ),
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY hh:mm A"),
    },
    {
      name: (
        <div>
          Action <br />
        </div>
      ),
      center: true,
      cell: (row) => (
        <>
          {utils.hasPermission(
            primaryMenuRes,
            "Bom Creation",
            "bom_creation.delete",
          ) && (
            <>
              <RB.Button
                className="btn btn-flat me-1"
                onClick={showDelete(row)}
              >
                <Trash />
              </RB.Button>
            </>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Bom Creation",
            "bom_creation.edit",
          ) && (
            <>
              <RB.Button
                className="btn-flat me-1"
                title="Edit"
                onClick={handelEdit(row)}
              >
                <Edit2 />
              </RB.Button>
            </>
          )}
          <RB.Button className="btn btn-flat me-1" onClick={handleView(row)}>
            <Eye />
          </RB.Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    getBOMList();
  }, [page]);

  const getBOMList = () => {
    const fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    const toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";
    utils
      .callAPI(
        "get",
        `production/bom/list?page=${page}&per_page=${countPerPage}&product_id=${productName}&bom_name=${bomName}&from_date=${fromDate}&to_date=${toDate}&plant_id=${plantName}`,
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setBomList(res);
          setSearch("");
        } else {
          setBomList([]);
          setSearch("");
        }
      })
      .catch((err) => {
        setBomList([]);
        setSearch("");
      });
  };

  const getPlantList = () => {
    utils.callAPI("get", "purchaseorder/plant/list").then((res) => {
      if (res?.result) {
        setPlantList(res.result);
      }
    });
  };

  const getproduct = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProduct(res?.result);
        } else {
          setProduct([]);
        }
      })
      .catch((err) => {
        setProduct([]);
      });
  };
  useEffect(() => {
    getPlantList();
    getproduct();
  }, []);

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/production/bom/delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getBOMList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = () => {
    setPage(1);
    setSearch("search");
  };

  const handleReset = () => {
    setBomName("");
    setPlantName("");
    setDateRange([null, null]);
    setPage(1);
    setProductName("");
    setSearch("reset");
  };

  useEffect(() => {
    if (search == "search" || search == "reset") {
      getBOMList();
    }
  }, [search]);

  const productOptions = product.map((p) => ({
    value: p.id,
    label: p.productCode
      ? `${p.product_name} - (${p.productCode}) - ${p?.size} ${p?.unit?.toUpperCase() || ""}`
      : p.product_name,
  }));

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <RB.Card.Header>
            <div className="floating-btns-holder-artisan">
              {utils.hasPermission(
                primaryMenuRes,
                "Bom Creation",
                "bom_creation.create",
              ) && (
                <a
                  href
                  className="btn btn-dark btn-circle"
                  variant="dark"
                  onClick={handleAddClick}
                >
                  <AddCircle />
                </a>
              )}
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(
              primaryMenuRes,
              "Bom Creation",
              "bom_creation.view",
            ) && (
              <>
                <RB.Row className="mb-3">
                  <RB.Col md={2} className="mt-2">
                    <RB.Form.Control
                      placeholder="BOM Name"
                      value={bomName}
                      onChange={(e) => setBomName(e.target.value)}
                    />
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    {/* <RB.Form.Control
                    type="text"
                    placeholder="Product Name"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                  /> */}
                    <Select
                      options={productOptions}
                      value={
                        productName
                          ? productOptions.find(
                              (opt) => opt.value === productName,
                            )
                          : null
                      }
                      onChange={(selectedOption) =>
                        setProductName(
                          selectedOption ? selectedOption.value : null,
                        )
                      }
                      placeholder="Select Product Name"
                      isSearchable
                      isClearable
                    />
                  </RB.Col>

                  <RB.Col md={2} className="mt-2">
                    <RB.Form.Select
                      value={plantName}
                      onChange={(e) => setPlantName(e.target.value)}
                    >
                      <option value="">Plant Location</option>
                      {plantList.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    <DatePicker
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable
                      placeholderText="Select Date Range"
                      className="form-control"
                      dateFormat="yyyy-MM-dd"
                    />
                  </RB.Col>

                  <RB.Col md="2" className="mt-2">
                    <RB.Button
                      variant="primary"
                      className="me-2"
                      onClick={handleSearch}
                    >
                      Search
                    </RB.Button>
                    <RB.Button variant="secondary" onClick={handleReset}>
                      Reset
                    </RB.Button>
                  </RB.Col>
                </RB.Row>

                <DataTable
                  columns={columns}
                  data={bomList.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={bomList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={bomList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  striped
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default List;
